function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M52.092 34.518h-4.184a3.35 3.35 0 01-3.347-3.346 3.35 3.35 0 013.347-3.347h8.368a2.93 2.93 0 000-5.859h-3.347V18.62a2.93 2.93 0 00-5.86 0v3.386c-4.684.425-8.367 4.372-8.367 9.166 0 5.076 4.13 9.206 9.206 9.206h4.184a3.35 3.35 0 013.346 3.346 3.35 3.35 0 01-3.346 3.346h-8.368a2.93 2.93 0 000 5.86h3.346v3.346a2.93 2.93 0 005.86 0V52.89c4.684-.425 8.368-4.373 8.368-9.166 0-5.076-4.13-9.206-9.206-9.206zM65.69 69.036H34.31a2.93 2.93 0 000 5.86h31.38a2.93 2.93 0 000-5.86z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.518 0H15.482a2.93 2.93 0 00-2.93 2.93v85.51c0 .777.309 1.523.858 2.072l8.63 8.63a2.93 2.93 0 004.143 0l6.558-6.558 6.558 6.558a2.93 2.93 0 004.143 0L50 92.584l6.558 6.558a2.93 2.93 0 004.143 0l6.558-6.558 6.558 6.558a2.92 2.92 0 002.071.858c.75 0 1.5-.286 2.072-.858l8.63-8.63a2.93 2.93 0 00.858-2.072V2.93A2.93 2.93 0 0084.518 0zm-8.63 92.927l-6.558-6.558a2.93 2.93 0 00-4.143 0l-6.558 6.558-6.558-6.558a2.93 2.93 0 00-4.143 0l-6.558 6.558-6.558-6.558a2.93 2.93 0 00-4.143 0l-6.558 6.558-5.7-5.7V5.859h63.177v81.368l-5.7 5.7z",
  fill: "currentColor"
});

var SvgReceipt = function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgReceipt;